import React, { useState } from 'react';

import BottomSheet from 'components/BottomSheet';
import Button from 'components/Buttons/Button';

import DataPicker, { DataPickerModel } from './components/DataPicker';
import { Header, Title, Close } from './styles';

export interface Props {
  show: boolean;
  onClose: () => void;
  onConfirm: (value) => void;
  selected: string | undefined;
  title: string;
  button: string;
}

const TimePicker = ({ show, onClose, onConfirm, selected = '', title, button }: Props) => {
  const [value, setValue] = useState(selected);
  const populateTime = (from: number, to: number, interval: number): string[] => {
    const arr: string[] = [];
    for (let i = from; i <= to; i++) {
      for (let j = 0; j < 60; j += interval) {
        const hour = i;
        const minutes = j;
        let text = hour < 10 ? `0${hour}` : `${hour}`;
        text += ':';
        text += minutes < 10 ? `0${minutes}` : `${minutes}`;
        arr.push(text);
      }
    }
    return arr;
  };

  const arr = populateTime(1, 12, 30);
  const arrPeriod = ['AM', 'PM'];
  const data = [
    { list: arr, textAlign: 'right' },
    {
      list: arrPeriod,
      textAlign: 'left',
    },
  ] as DataPickerModel[];

  const onChange = (value: string): void => {
    setValue(value);
  };

  const handleConfirm = (): void => {
    onConfirm(value);
  };

  return data ? (
    <>
      <BottomSheet show={show} onClose={onClose} noHeader>
        <>
          <Header>
            <Title>{title}</Title>
            <Close src="/corporate/images/close.svg" onClick={onClose} />
          </Header>
          <DataPicker data={data} initialValue={value} change={onChange} />
          <Button onClick={handleConfirm}>{button}</Button>
        </>
      </BottomSheet>
    </>
  ) : (
    <div>loading</div>
  );
};
export default TimePicker;
